import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import getAppConfig from '../../../config/appConfig';
import Utils from '../../../utils/Utils';
import settings from '../../../devices/all/settings';

class LoginDynamic extends AbstractRequestTask {
    constructor(mail = '', isCM = false, cm_access_token = null) {
        super();
        this.mail = mail;
        this.isCM = isCM;
        this.apiVersion = isCM ? '1.0.0' : null;
        this.cm_access_token = cm_access_token;
    }

    getHeaders() {
        if (this.isCM) {
            let headerParams = {
                'Content-Type': 'application/x-www-form-urlencoded'
            };
            
            return headerParams;
        }

        return {};
    }

    getUrl() {
        let url,
            http = 'https://';
        if (this.getMethod() === 'POST' && this.isCM) {
            const config = getAppConfig();
            url = `${config.end_point_music}/middleware/user/isLoggedIn?`;
            url += Utils.buildQueryParams(this.getGETParams());
            // url ya contiene el http/https
            return url;
        } else {
            url = Launcher.get('akamai_mfwk');

            return `${http}${url}/services/user/logindynamic`;
        }
    }

    getParams() {
        if (this.getMethod() === 'POST' && this.isCM) {
            const params = {};

            if (this.mail) {
                params.mail = this.mail;
            }

            return params;
        }

        // Si es Get
        return this.getGETParams();
    }

    getGETParams() {
        const params = super.getParams();
        params.version = this.apiVersion ? this.apiVersion : '1.0.0';

        if (this.isCM) {
            if (this.cm_access_token) {
                params.cm_access_token = this.cm_access_token;
            }

            const { tenant_code } = settings;
            return { ...params, tenant_code };
        } else {
            const email = { email: this.mail };
            return { ...params, email };
        }
    }

    isValid(data) {
        if (!data.response) {
            return false;
        }
        return true;
    }

    success(data, b) {
        this.resolve(data);
    }

    getMethod() {
        return this.isCM ? 'POST' : 'GET';
    }

    replaceProtocol(url) {
        return this.isCM ? url : super.replaceProtocol(url);
    }

    getEncType() {
        if (this.getMethod() === 'POST') {
            return 'application/x-www-form-urlencoded';
        }
        return super.getEncType();
    }

    getShowErrorModal(){
      return false;
    }
}

export default LoginDynamic;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/LoginDynamic.js